__turbopack_context__.v({
  "StreamField__Component": "B_J_Dq_StreamField__Component",
  "StreamField__Component--BarChartBlock": "B_J_Dq_StreamField__Component--BarChartBlock",
  "StreamField__Component--ColumnChartBlock": "B_J_Dq_StreamField__Component--ColumnChartBlock",
  "StreamField__Component--ImageBlock": "B_J_Dq_StreamField__Component--ImageBlock",
  "StreamField__Component--ImageGallery": "B_J_Dq_StreamField__Component--ImageGallery",
  "StreamField__Component--ItemGridSpan-1": "B_J_Dq_StreamField__Component--ItemGridSpan-1",
  "StreamField__Component--ItemGridSpan-2": "B_J_Dq_StreamField__Component--ItemGridSpan-2",
  "StreamField__Component--ItemGridSpan-3": "B_J_Dq_StreamField__Component--ItemGridSpan-3",
  "StreamField__Component--ItemGridSpan-4": "B_J_Dq_StreamField__Component--ItemGridSpan-4",
  "StreamField__Component--ItemGridSpan-6": "B_J_Dq_StreamField__Component--ItemGridSpan-6",
  "StreamField__Component--LineChartBlock": "B_J_Dq_StreamField__Component--LineChartBlock",
  "StreamField__Component--PolarChartBlock": "B_J_Dq_StreamField__Component--PolarChartBlock",
  "StreamField__Component--SmallPadding": "B_J_Dq_StreamField__Component--SmallPadding",
  "StreamField__Component--StackedAreaChartBlock": "B_J_Dq_StreamField__Component--StackedAreaChartBlock",
  "StreamField__Component--Table": "B_J_Dq_StreamField__Component--Table",
  "skeleton-loading": "B_J_Dq_skeleton-loading",
});
